export default window.hasOwnProperty("cordova");
